import { render } from "./Feed.vue?vue&type=template&id=bb79440e"
import script from "./Feed.vue?vue&type=script&lang=js"
export * from "./Feed.vue?vue&type=script&lang=js"

import "./Feed.vue?vue&type=style&index=0&id=bb79440e&lang=css"

import exportComponent from "/Users/raullarosa/Development/raullarosa.com/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__